import { render } from "./PriceRules.vue?vue&type=template&id=33ffd120&scoped=true"
import script from "./PriceRules.vue?vue&type=script&lang=js"
export * from "./PriceRules.vue?vue&type=script&lang=js"

import "./PriceRules.vue?vue&type=style&index=0&id=33ffd120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ffd120"]])

export default __exports__